import {jsx as _jsx} from "react/jsx-runtime";import {Suspense} from 'react'
import viewerNotOnTeamQuery, {

} from '../__generated__/ViewerNotOnTeamQuery.graphql'
import useQueryLoaderNow from '../hooks/useQueryLoaderNow'
import useSubscription from '../hooks/useSubscription'
import NotificationSubscription from '../subscriptions/NotificationSubscription'
import {LoaderSize} from '../types/constEnums'
import {Loader} from '../utils/relay/renderLoader'
import ViewerNotOnTeam from './ViewerNotOnTeam'

const ViewerNotOnTeamRoot = () => {
  const searchParams = new URLSearchParams(location.search)
  const teamId = searchParams.get('teamId')
  const meetingId = searchParams.get('meetingId')
  useSubscription('ViewerNotOnTeamRoot', NotificationSubscription)
  const queryRef = useQueryLoaderNow(viewerNotOnTeamQuery, {
    teamId,
    meetingId
  })
  return (
    _jsx(Suspense, { fallback: _jsx(Loader, { size: LoaderSize.WHOLE_PAGE,} ), children: 
      queryRef && _jsx(ViewerNotOnTeam, { queryRef: queryRef,} )
    })
  )
}

export default ViewerNotOnTeamRoot
